const initialState = {
    category: [],
    newsList: [],
    themesList: [],
    newsDetail: {},
    themesDetail: [],
    pageNum: 1,
    total: 0
};
export const actionTypes = {
    GET_NEWS_LIST: "GET_NEWS_LIST",
    RESPONSE_NEWS_LIST: "RESPONSE_NEWS_LIST",
    GET_NEWS_DETAIL: "GET_NEWS_DETAIL",
    RESPONSE_NEWS_DETAIL: "RESPONSE_NEWS_DETAIL",
    GET_THEMES_LIST: "GET_THEMES_LIST",
    RESPONSE_THEMES_LIST: "RESPONSE_THEMES_LIST",
    GET_THEMES_DETAIL: "GET_THEMES_DETAIL",
    RESPONSE_THEMES_DETAIL: "RESPONSE_THEMES_DETAIL"
};

export const actions = {
    get_news_list: function () {
        return {
            type: actionTypes.GET_NEWS_LIST
        }
    },
    get_news_detail: function (id) {
        return {
            type: actionTypes.GET_NEWS_DETAIL,
            id
        }
    },
    get_themes_list: function () {
        return {
            type: actionTypes.GET_THEMES_LIST
        }
    },
    get_themes_detail: function (id) {
        return {
            type: actionTypes.GET_THEMES_DETAIL,
            id
        }
    }
};

export function reducer(state = initialState, action) {
    switch (action.type) {
        case actionTypes.RESPONSE_NEWS_LIST:
            return {
                ...state, newsList: [...action.data]
            };
        case actionTypes.RESPONSE_NEWS_DETAIL:
            return {
                ...state, newsDetail: action.data
            };
        case actionTypes.RESPONSE_THEMES_LIST:
            return {
                ...state, themesList: [...action.data]
            };
        case actionTypes.RESPONSE_THEMES_DETAIL:
            return {
                ...state, themesDetail: action.data
            };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/newsReducer.js